import React from 'react';
import Slider from 'react-slick';
import DoctorSlide from './DoctorSide'; // the file above
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Dr02 from './Pictures/DrAnkita.jpg';
import Dr01 from './Pictures/DrDeepanwita.jpg';

const doctors = [
  {
    name: "Dr. Deepanwita",
    specialty: "BDS MDS(Periodontist & Oral Implantologist)",
    goldm: "Gold Medalist",
    description: "Dr Deepanwita is a Periodontist and oral implantologist. She is gold medalist in BDS. She specialises in the treatment of gum diseases, implants and lasers.She has a vast experience in the field of periodontics, lasers and implants. She has been working as a consultant periodontist in multiple prestigious dental hospitals in and around Hyderabad.",
    image: Dr01
  },
  {
    name: "Dr. Ankita Grover",
    specialty: "BDS MDS (Oral and Maxillafacial Prosthodontist and Implantologist)",
    goldm: "Gold Medalist",
    description: "Dr. Ankita Grover, Oral and maxillofacial Prosthodontist believes that a healthy oral environment and a well-crafted smile can transform lives. She specialises in replacement of missing teeth and smile designing. Her motto is to provide a comfortable environment with a focus on restoring the function and aesthetics of the patient.",
    image: Dr02
  }
];

const DoctorCarousel = () => {


  return (
      <div style={{ width: '90%', margin: '40px auto', maxWidth: '1000px' }}>
          <Slider
              dots={true}
              infinite={true}
              speed={500}
              autoplay={true}
              autoplaySpeed={5000}
              slidesToShow={1}
              slidesToScroll={1}
              arrows={true}
          >
              {doctors.map((doc, idx) => (
                  <div key={idx}>
                      <DoctorSlide doctor={doc} />
                  </div>
              ))}
          </Slider>
      </div>
  );
};

export default DoctorCarousel;
